import Layout from './layouts/Main.vue'
import ModuleMixin from './shared/mixins/ModuleMixin';
import ManageStoreMixin from './shared/mixins/ManageStoreMixin';
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';

export default {
    mixins: [
        BaseGestaoMixin,
        ModuleMixin,
        ManageStoreMixin,
    ],
	components: {
	    Layout: Layout,
	},
}
